import createScrollOpt from "@/assets/js/vuescrollOption";
import { area_list } from "@/assets/js/region";
import { levelOptions } from "@/assets/js/select";
import { correctStatus } from "@/assets/js/apiStatus";
import { getLecturers } from "@/api/agency/agency";
import commonFun from "@/assets/js/yioks";
import class_d from '@/assets/images/timetable/class_d.png';
import class_c from '@/assets/images/timetable/class_c.jpg';
import {mapMutations, mapActions} from "vuex";
export default {
  _myOpt: {
    rearEndErrorMsg: '培训班信息有误。',
    class_d,
    class_c,
  },
  data() {
    const { mobile_phone, idCard_number } = commonFun;
    const excelFileUrl = '/uploads/import_tpl/批量录入学员模板.xlsx'
    const testFile = {
      type: {
        reg: /^.*\.(xls|xlsx)$/i,
        msg: "请上传Excel文件"
      },
      size: {
        reg: 20,
        msg: "文件不得多于20M"
      }
    };
    const formRules = {
      className: [
        { required: true, message: "请填写培训班名称", trigger: "blur" }
      ],
      period: [
        {
          required: true,
          // 期数为下拉框时候的校验规则😊
          // validator: (rule, value, callback) => {
          //   if (value === "") {
          //     this.periodSelErr = true;
          //     callback(new Error("请选择培训班期数"));
          //   } else {
          //     this.periodSelErr = false;
          //     callback();
          //   }
          // },

          // 期数为输入框时候的校验规则
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('期数不能为空'));
            } else {
              const val = Number(value);
              if (!Number.isInteger(val)) {
                callback(new Error('请输入整数值'));
              } else {
                if (value < 1) {
                  callback(new Error('期数不得小于1'));
                } else {
                  // 如果后台校验有问题
                  if (this.periodAjaxTestErr) {
                    callback(new Error(this.periodAjaxTestMsg));
                  } else {
                    callback();
                  }
                }
              }
            }
          },
          trigger: "change"
        }
      ],
      trainStart: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请选择培训开始日期"));
            }
            else if(this.trainTimeAjaxErr) {
              this.trainTimeAjaxErr = false;
              callback(new Error(this.trainTimeAjaxErrMsg));
            }
            else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      trainEnd: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请选择培训结束日期"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      lecturer: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value == "") {
              const userType = this.$store.state.userInfo.member_type;
              if(userType=='system'||userType=='super'){
                // this.lectureSelErr = true;
                callback(new Error("请选择讲师"));
              }
            }
            
            // 如果后台校验有问题
            if (this.lecturerAjaxTestErr) {
              // this.lectureSelErr = true;
              callback(new Error(this.lecturerAjaxTestMsg));
            } else {
              // this.lectureSelErr = false;
              callback();
            }
          },
          trigger: "change"
        }
      ],
      cost: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请填写培训费用"));
            } else {
              if (isNaN(value)) {
                callback(new Error("请填写数字"));
              } else {
                callback();
              }
            }
          },
          trigger: "blur"
        }
      ],
      lodgingPlace: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (this.formData.ifLodging) {
              value === "" ? callback(new Error("此项不能为空")) : callback();
            } else {
              callback();
            }
          },
          trigger: "blur"
        }
      ],
      eatPlace: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (this.formData.ifEat) {
              value === "" ? callback(new Error("此项不能为空")) : callback();
            } else {
              callback();
            }
          },
          trigger: "blur"
        }
      ],
      reportStart: [
        {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请选择报到开始日期"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      reportEnd: [
        {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请选择报到开始时间"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      leaveDate: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请选择离会日期"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      leaveTime: [
        {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请选择离会时间"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }
      ],
      reportAddress: [
        { required: true, message: "此项不能为空", trigger: "blur" }
      ],
      trainAddress: [
        { required: true, message: "此项不能为空", trigger: "blur" }
      ],
      courseAddress: [
        { required: true, message: "此项不能为空", trigger: "blur" }
      ],
      saveStus: [
        {
          required: true,
          validator: (rule, value, callback) => {
            // console.log("校验学员名单");
            if (this.testStus === false) {
              callback(new Error("学员名单内容有误"));
            } else {
              callback();
            }
          },
          // trigger: "change"
        }
      ],
      saveContact: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (this.testContact === false) {
              callback(new Error("联系人名单内容有误"));
            } else {
              callback();
            }
          },
          // trigger: "change"
        }
      ]
      
    };
    const lodgingSelList = [
      { val: 1, text: "学员自理" },
      { val: 2, text: "培训机构支付" }
    ];
    const eatSelList = [
      { val: 1, text: "学员自理" },
      { val: 2, text: "培训机构支付" }
    ];
    const travelList=[
      { val: 1, text: "学员自理" },
      { val: 2, text: "培训机构支付" }
    ]
    const periodList = [
      { val: 1, text: "第一期" },
      { val: 2, text: "第二期" },
      { val: 3, text: "第三期" }
    ];
    /*const validatePhone = (rule, value, callback) => {
      if (mobile_phone(value)) {
        callback();
      } else {
        callback(new Error("请输入有效的11位手机号"));
      }
    };*/
    /*const validateNumberId = (rule, value, callback) => {
      if (idCard_number(value)) callback();
      else callback(new Error("请输入有效的身份证号"));
    };*/
    const validateProvince = (rule, value, callback) => {
      if (value !== "") {
        this.provinceSelErr = false;
        callback();
      } else {
        this.provinceSelErr = true;
        callback(new Error("请选择开班省份"));
      }
    };
    const validateCity = (rule, value, callback) => {
      if (value !== "") {
        this.citySelErr = false;
        callback();
      } else {
        this.citySelErr = true;
        callback(new Error("请选择开班市"));
      }
    };
    const validateCounty = (rule, value, callback) => {
      /*if (value !== "") {
        this.countySelErr = false;
        callback();
      } else {
        this.countySelErr = true;
        callback(new Error("请选择开班县"));
      }*/
      callback();
    };
    const validateAssLec = (rule, value, callback, i) => {
      if (this.formData.assistantLecturer[i].isTestErr) {
        callback(new Error(this.formData.assistantLecturer[i].errMsg));
      } else {
        this.$set(this.formData.assistantLecturer[i], "isTestErr", false);
        this.$set(this.formData.assistantLecturer[i], "errMsg", '');
        callback();
      }
    };
    return {
      dateStatus: this.$route.params.status || '',
      ajaxStatus: '',
      loadExcelUrl: excelFileUrl,
      testFile,
      excelVal: '',
      formRules,
      levelOptions,
      lodgingSelList,
      eatSelList,
      periodList,
      travelList,
      // validatePhone,
      // validateNumberId,
      validateProvince,
      validateCity,
      validateCounty,
      validateAssLec,
      selTestErrorBorder: "1px solid #f56c6c",
      selTestRightBorder: "1px solid #67c23a",
      // null 时表示为初始样式，即没有经过校验时候的样式
      provinceSelErr: null,
      citySelErr: null,
      countySelErr: null,
      periodSelErr: null,
      // lectureSelErr: null,
      vuescrollOpt: createScrollOpt(),
      disScrollOpt: createScrollOpt(true),
      tipsFlag: false,
      backComfim: false,
      tipMsg: '提交后不可更改，是否确定？',
      /* 用于接收后台校验结果后重新对表单进行校验，后期可以把这些数据写在 组件实例data之外 */
      periodAjaxTestErr: false,
      periodAjaxTestMsg: '',
      lecturerAjaxTestErr: false,
      lecturerAjaxTestMsg: '',
      /*  ----- end -----  */
      /* 分别表示学员名单和联系人信息是否校验通过 */
      testStus: false,
      testContact: false,
      trainTimeAjaxErr: false,
      trainTimeAjaxErrMsg: '',
      copyData: {},
      level: "",
      copyLevel: "",
      levelFlag: false,
      levelMsg: "切换等级后，所填的信息将会被重置<br/>确定切换吗？",
      loading: false,
    }
  },
  methods: {
    ...mapMutations(["setStoreOrgData"]),
    ...mapActions(["actionStoreOrgData"]),
    // 获取讲师列表
    getLecturerList() {
      getLecturers({
        class_level: this.formData.class_level
      }).then(({ data }) => {
        // const res = JSON.parse(JSON.stringify(response.data));
        if (data.status === correctStatus) {
          const assiantList = data.result.teacher_assistant_list;
          const teacherList = data.result.teacher_list;
          this.lecturerList = JSON.parse(JSON.stringify(teacherList));
          this.lecturerStore = JSON.parse(JSON.stringify(teacherList));
          this.optionalAssistantLec = [
            ...assiantList
          ];
          this.assistantLecturerList = JSON.parse(JSON.stringify(assiantList));
          this.assistantStore = JSON.parse(JSON.stringify(assiantList));
        }
      });
    },
    // 获取省数据
    getProvinceList() {
      const vessel = [];
      for (const reg of area_list) {
        vessel.push({
          text: reg.regionName,
          id: reg.id
        });
      }
      this.provinceList = [...vessel];
    },
    cityChange() {
      this.formData.classAddress.county = "";
      const vessel = [];
      if (this.curProvince !== undefined) {
        const curCity = this.curProvince.city.find(item => {
          return item.id === this.formData.classAddress.city;
        });
        if (curCity !== undefined && curCity.county) {
          for (const county of curCity.county) {
            vessel.push({
              text: county.regionName,
              id: county.id
            });
          }
        }
      }
      this.countyList = [...vessel];
    },
    provinceChange() {
      const vessel = [];
      const curProvince = area_list.find(item => {
        return item.id === this.formData.classAddress.province;
      });
      this.curProvince = curProvince;
      this.formData.classAddress.city = "";
      this.cityChange();
      if (curProvince !== undefined) {
        for (const city of curProvince.city) {
          vessel.push({
            text: city.regionName,
            id: city.id
          });
        }
      }

      this.cityList = [...vessel];
    },
    excelBeforeRemove() {
      return false;
    },
    temporarySave() {
      this.$refs["mainForm"].validate(valid => {
        if (valid) {
          this.ajaxCreatClass({ status: "Edit" });
        } else {
          this.$message.error("必填项不能为空");
        }
      });
    },
    saveStuList() {
      this.$refs["stusDialogForm"].validate(valid => {
        const stusData = JSON.parse(JSON.stringify(this.stusData));
        if (valid) {
          if(stusData.stusInfoList.length<this.minStus || stusData.stusInfoList.length>this.maxStus){
            this.$message.error("学员数量必须在18人到24人之间");
            return;
          }
          this.$set(this.formData, "saveStus", [...stusData.stusInfoList]);
          this.ifStuDiaShow = false;
          this.testStus = true;
        } else {
          // this.testStus = false;
          return false;
        }
      });
    },
    saveExcelData() {
      if (this.excelVal !== "") {
        if(this.excelVal.student_list.length > this.maxStus){
          this.$message.error("学员数量必须在18人到24人之间，请重新上传");
          return;
        }
        this.ifExcelDiaShow = false;
        const excelData = [];
        for (const [i, item] of this.excelVal.student_list.entries()) {
          if (i > 23) break;
          const stuItem = this.stusData.stusInfoList[i];
          // push 一个 { ...stuItem, ...item } 而不是 {...item} 是因为要保留原有每一项的id字段
          excelData.push({ ...stuItem, ...item });
          // this.$set(this.stusData.stusInfoList, i, { ...stuItem, ...item });
          // this.stusData.stusInfoList[i] = {...stuItem,...item}
          // console.log(this.stusData.stusInfoList[i], stuItem)
        }
        this.stusData.stusInfoList = [...excelData];
        /*const len = this.stusData.stusInfoList.length;
        if(len < this.maxStus) {
         for(let i = 0; i < (this.maxStus - len); i++) {
           this.stusData.stusInfoList.push({
             name: "",
             phone: "",
             id_num: ""
           });
         }
        }*/

        this.$nextTick(() => {
          this.excelDiaLetStusDiaOpen = true;
          this.ifStuDiaShow = true;
        });
      } else {
        this.$message.error("请先上传文件");
      }
    },
    saveContactList() {
      this.$refs["contactDialogForm"].validate(valid => {
        const contactData = JSON.parse(JSON.stringify(this.contactData));
        if (valid) {
          this.$set(this.formData, "saveContact", [
            ...contactData.contactInfoList
          ]);
          this.ifContactDiaShow = false;
          this.testContact = true;
        } else {
          // this.testContact = false
          return false;
        }
      });
    },
    addContact() {
      if (this.contactData.contactInfoList.length > 8) return;
      this.contactData.contactInfoList.push({
        name: "",
        phone: "",
        email: "",
        id: this.contactData.contactInfoList.length + 1
      });
    },
    delContact(item) {
      const index = this.contactData.contactInfoList.indexOf(item);
      index !== -1 && this.contactData.contactInfoList.splice(index, 1);
    },
    excelDiaCloseHandle() {
      this.$refs['excelUpload'].reset()
    },
    addHost(dataKey, itemData, length = 1) {
      if (this.formData[dataKey].length > length) return;
      this.formData[dataKey].push(itemData);
    },
    removeHost(item, dataKey) {
      const index = this.formData[dataKey].indexOf(item);
      if (index !== -1) {
        this.formData[dataKey].splice(index, 1);
      }
    },
    stuDiaOpenHandle() {
      // debugger
      const formData = JSON.parse(JSON.stringify(this.formData));
      this.$nextTick(() => {
        this.$refs["stusDialogForm"].clearValidate();
      });
      if(this.excelDiaLetStusDiaOpen === false) {
        this.$set(this.stusData, "stusInfoList", formData.saveStus);
      }
    },
    contactDiaOpen() {
      this.$nextTick(() => {
        this.$refs["contactDialogForm"].clearValidate();
      });
      const formData = JSON.parse(JSON.stringify(this.formData));
      this.$set(this.contactData, "contactInfoList", formData.saveContact);
    },
    showStusDialog() {
      this.excelDiaLetStusDiaOpen = false;
      this.ifStuDiaShow = true;
    },
    showExcelDialog() {
      this.ifExcelDiaShow = true;
    },
    showContactDialog() {
      this.ifContactDiaShow = true;
    },
    stuDiaEsc() {
      this.ifStuDiaShow = false;
    },
    contactDiaEsc() {
      this.ifContactDiaShow = false;
    },
    getTimeStemp(date, time) {
      // console.log('时间 --> ', date, time)
      const timeArr = time.split(":").map((item)=>{
        return Number(item);
      });
      return new Date(date).setHours(timeArr[0], timeArr[1]);
    },
    lecturerFilter(val) {
      this.lecturerList = JSON.parse(JSON.stringify(this.lecturerStore));
      if(val) {
        this.lecturerList = this.lecturerList.filter((item) => {
          return item.teacher_name_unit.includes(val);
        });
        if(this.lecturerList.length === 1) {
          this.formData.lecturer = this.lecturerList[0].user_id;
        }
      } else {
        this.formData.lecturer = "";
      }
    },
    lecturerBlur() {
      setTimeout(() => {
        this.lecturerList = JSON.parse(JSON.stringify(this.lecturerStore));
      }, 100);
    },
    assistantFilter(val) {
      this.assistantLecturerList = JSON.parse(JSON.stringify(this.assistantStore));
      if(val) {
        this.assistantLecturerList = this.assistantLecturerList.filter((item) => {
          return item.teacher_name_unit.includes(val);
        });
        if(this.assistantLecturerList.length === 1) {
          this.formData.assistantLecturer[this.assistantIdx].val = this.assistantLecturerList[0].user_id;
        }
      } else {
        this.formData.assistantLecturer[this.assistantIdx].val = "";
      }
    },
    assistantBlur() {
      setTimeout(() => {
        this.assistantLecturerList = JSON.parse(JSON.stringify(this.assistantStore));
      }, 100);
    },
  },
  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "image-up": () => import("@/components/UpImage/UpImage"),
    "file-upload": () => import('@/components/UpFile/UpFile'),
    "yioks-tips": () => import('@/components/Tips/Dialog')
  },
  computed: {
    calendarShow() {
      let day = new Date();
      const delayDay = day.getDate() + 7;
      day.setDate(delayDay);
      const timestamp = day.getTime();
      return timestamp;
    },
    // 开始时间日历中，禁用当前日期之前的日期
    trainStartOpt() {
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        // 小于当天0点的时间不可用
        // 当前日期 + 7天  C级是14天
        disabledDate: time => {
          const tempDate = new Date().setHours(0,0,0,0);
          let timestamp = new Date(tempDate).getTime();
          const userType = this.$store.state.userInfo.member_type;
          // 系统管理员 可以选择当前日期， 机构管理员只能选择当前日期+7
          if(this.formData.class_level === 'C'){
            (userType==='organ') && (this.dateStatus === 'New' || this.dateStatus === 'Edit') && (timestamp += 14*24*60*60*1000);
          }else{
            (userType==='organ') && (this.dateStatus === 'New' || this.dateStatus === 'Edit') && (timestamp += 7*24*60*60*1000);
          }
          return time.getTime() < timestamp;
        },
      };
    },
    // 结束时间日历中,禁用开始时间之前的日期
    trainEndOpt() {
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        disabledDate: time => {
          if(Number(this.formData.trainStart)) {
            /*if(this.formData.class_level === "C") {
              return time.getTime() < Number(this.formData.trainStart) + 14*24*60*60*1000;
            }else{
              return time.getTime() < Number(this.formData.trainStart);
            }*/
            return time.getTime() < Number(this.formData.trainStart);
          } else {
            return time.getTime() < new Date().getTime();
          }
        },
      };
    },
    reportStartOpt() {
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        disabledDate: time => {
          const tempDate = new Date().setHours(0,0,0,0);
          return time.getTime() < new Date(tempDate).getTime()
        },
      };
    },
    reportEndOpt() {
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        disabledDate: time => time.getTime() < Number(this.formData.reportStart),
      };
    },
    leaveDateOpt() {
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        disabledDate: time => {
          if(Number(this.formData.trainEnd)) {
            return time.getTime() < Number(this.formData.trainEnd)
          } else {
            return time.getTime() < new Date().getTime()
          }
        }
      };
    },
  },
  watch: {
    "formData.ifLodging": {
      handler: function(val) {
        val === false && this.$refs["mainForm"].clearValidate("lodgingPlace");
      }
    },
    "formData.ifEat": {
      handler: function(val) {
        val === false && this.$refs["mainForm"].clearValidate("eatPlace");
      }
    },
    'testStus': {
      handler: function(val) {
        this.$refs["mainForm"].validateField("saveStus");
      }
    },
    'testContact': {
      handler: function(val) {
        this.$refs["mainForm"].validateField("saveContact");
      }
    },
    // "formData.assistantLecturer": {
    //   handler: function(formAssist) {
    //     // this.optionalAssistantLec = this.assistantLecturerList.filter(item => {
    //     //   return (formAssist.filter(ass => {
    //     //     return item.user_id === ass.val
    //     //   }).length === 0)
    //     // })
    //   },
    //   deep: true
    // },
  },
}